import React from 'react';
import { Spinner } from 'reactstrap';

import styles from './BusyIndicator.module.css';

function BusyIndicator(props) {
    return props.isBusy === true ?
        (
            <div className={styles.spinner}>
                <Spinner color="info" />
            </div>
        ) : null;
}

export { BusyIndicator };